// pdfSetup.js - PDF.js configuration utility (CDN-based approach)
export const setupPdfJs = () => {
  // Check if PDF.js is already loaded from CDN
  if (typeof window !== "undefined" && window.pdfjsLib) {
    // Configure the worker source for better performance
    window.pdfjsLib.GlobalWorkerOptions.workerSrc = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js"

    return window.pdfjsLib
  }
  
  // Fallback - this should be loaded via CDN in the HTML head
  throw new Error("PDF.js library not loaded. Please include PDF.js from CDN.")
}
